{
  "removeButtonLabel": "Κατάργηση",
  "removeDescription": "Πατήστε Διαγραφή για να καταργήσετε την ετικέτα."
}
